"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Menu, Mountain, X } from "lucide-react";
import { useState } from "react";
import { headerNavigation } from "@/lib/navigation";
import { MobileNavigation } from "@/components/layout/MobileNavigation";
import { PrimaryButton } from "@/components/shared/PrimaryButton";

export function Header() {
  const pathname = usePathname();
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b bg-white/95 backdrop-blur" style={{ borderColor: "var(--border-soft)" }}>
      <div className="container-shell h-16 md:h-[74px] flex items-center justify-between gap-4">
        <Link href="/" className="flex items-center gap-3">
          <div className="h-9 w-9 rounded-xl hero-gradient flex items-center justify-center text-white shadow-sm">
            <Mountain className="h-5 w-5" />
          </div>
          <div>
            <p className="headline-display text-lg font-bold leading-none" style={{ color: "var(--text-primary)" }}>
              Everest
            </p>
            <p className="text-[11px] font-semibold tracking-wide uppercase" style={{ color: "var(--text-muted)" }}>
              Video Data Management
            </p>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {headerNavigation.map((item) => {
            const active = pathname === item.href;
            return (
              <Link
                key={item.href}
                href={item.href}
                className="px-3 py-2 rounded-lg text-sm font-semibold transition-colors"
                style={{
                  color: active ? "var(--brand-700)" : "var(--text-secondary)",
                  background: active ? "#e8f2fd" : "transparent",
                }}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="hidden md:block">
          <PrimaryButton href="/request-demo">Request Demo</PrimaryButton>
        </div>

        <button
          type="button"
          className="md:hidden h-10 w-10 rounded-lg border flex items-center justify-center"
          style={{ borderColor: "var(--border-soft)", color: "var(--text-secondary)" }}
          onClick={() => setOpen((prev) => !prev)}
          aria-label="Toggle navigation menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      <MobileNavigation open={open} onNavigate={() => setOpen(false)} />
    </header>
  );
}
